import React from 'react';

const ErrorDisplay = ({ errorMessage }) => {
  return <div className="error-message">Error: {errorMessage}</div>;
};

export default ErrorDisplay;
